import PropTypes from 'prop-types';
import React from 'react';
import { SCButton, SCTooltip } from 'rollup-allspark';
import AutoResizingTextarea from '../AutoResizingTextarea';

export const MAX_QUERY_LENGTH = 1000;

const Composer = ({
  value,
  onChange,
  onSubmit,
  onCancel,
  isStreaming,
  disabled,
  disabledReason,
}) => {
  const trimmed = value.trim();
  const tooLong = value.length > MAX_QUERY_LENGTH;
  const canSend = !disabled && !isStreaming && trimmed.length > 0 && !tooLong;

  const onKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.metaKey) {
      e.preventDefault();
      if (canSend) onSubmit();
    }
  };

  const sendButton = (
    <SCButton
      size="auto"
      variant="primary"
      disabled={!canSend}
      className="flex h-8 w-8 items-center justify-center rounded-full text-lg"
      action={onSubmit}
    >
      <i className="kt-send" />
    </SCButton>
  );

  return (
    <div className="border-t border-grey-light bg-white p-3">
      <div className="flex flex-col gap-y-2 rounded-lg border border-grey p-2">
        <AutoResizingTextarea
          value={value}
          onChange={e => onChange(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder={
            disabled ? disabledReason || 'kAI is unavailable' : 'Ask kAI…'
          }
          disabled={disabled}
          minHeight={36}
          maxHeight={160}
        />
        <div className="flex items-center justify-between">
          <span
            className={`text-mini ${
              tooLong ? 'text-red-dark' : 'text-grey-darker'
            }`}
          >
            {tooLong ? `${value.length}/${MAX_QUERY_LENGTH}` : ''}
          </span>
          {isStreaming ? (
            <SCButton
              size="sm"
              variant="secondary-outline"
              label="Stop"
              action={onCancel}
            />
          ) : (
            <SCTooltip
              content={disabled ? disabledReason || 'kAI is unavailable' : 'Send'}
            >
              {sendButton}
            </SCTooltip>
          )}
        </div>
      </div>
    </div>
  );
};

Composer.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  isStreaming: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string,
};

export default Composer;
